/**
 * @generated SignedSource<<acb16ea7afb6f76ab1f18c7963b8fd33>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MoqStepType = "CUSTOM" | "FIXED";
export type MoqTargetRuleType = "PRODUCT" | "VARIANT";
export type moqRuleEditor_MoqRuleDetailQuery$variables = {
  id: string;
};
export type moqRuleEditor_MoqRuleDetailQuery$data = {
  readonly moqRule: {
    readonly colors: ReadonlyArray<{
      readonly colorID: number;
      readonly productID: number;
    }>;
    readonly customTiers: string;
    readonly fixedStep: number | null;
    readonly globalColors: ReadonlyArray<string>;
    readonly id: string;
    readonly minimumQuantity: number;
    readonly moqRuleID: number;
    readonly name: string;
    readonly printTypes: ReadonlyArray<{
      readonly printTypeID: number;
    }>;
    readonly products: ReadonlyArray<{
      readonly productID: number;
    }>;
    readonly stepType: MoqStepType;
    readonly targetRuleType: MoqTargetRuleType;
  };
};
export type moqRuleEditor_MoqRuleDetailQuery = {
  response: moqRuleEditor_MoqRuleDetailQuery$data;
  variables: moqRuleEditor_MoqRuleDetailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productID",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "MoqRule",
    "kind": "LinkedField",
    "name": "moqRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "moqRuleID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "minimumQuantity",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "targetRuleType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stepType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fixedStep",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customTiers",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MoqRuleProduct",
        "kind": "LinkedField",
        "name": "products",
        "plural": true,
        "selections": [
          (v1/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MoqRulePrintType",
        "kind": "LinkedField",
        "name": "printTypes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "printTypeID",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MoqRuleColor",
        "kind": "LinkedField",
        "name": "colors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "colorID",
            "storageKey": null
          },
          (v1/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "globalColors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "moqRuleEditor_MoqRuleDetailQuery",
    "selections": (v2/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "moqRuleEditor_MoqRuleDetailQuery",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "539b13ab92729805d424438ba0a3ab41",
    "id": null,
    "metadata": {},
    "name": "moqRuleEditor_MoqRuleDetailQuery",
    "operationKind": "query",
    "text": "query moqRuleEditor_MoqRuleDetailQuery(\n  $id: ID!\n) {\n  moqRule(id: $id) {\n    id\n    moqRuleID\n    name\n    minimumQuantity\n    targetRuleType\n    stepType\n    fixedStep\n    customTiers\n    products {\n      productID\n    }\n    printTypes {\n      printTypeID\n    }\n    colors {\n      colorID\n      productID\n    }\n    globalColors\n  }\n}\n"
  }
};
})();

(node as any).hash = "e45edad985ec4a0ee6ce273a03660a67";

export default node;
